import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row, CardBody, Table } from 'reactstrap'

const certificateDataIso = [
  { key: 'welding_processes', title: 'Welding processes', prepare: 'join' },
  { key: 'product_types', title: 'Product types', prepare: 'join' },
  { key: 'type_of_welds', title: 'Type of welds', prepare: 'join' },
  { key: 'filler_material_groups', title: 'Filler material groups', prepare: 'join' },
  { key: 'filler_materials', title: 'Filler materials', prepare: 'join' },
  { key: 'material_groups', title: 'Material groups', prepare: 'join', noApproval: true },
  { key: 'dimension_t', title: 'Material thicknes (mm)' },
  { key: 'dimension_s', title: 'Deposited thickness (mm)' },
  { key: 'dimension_d', title: 'Outside pipe diam. (mm)' },
  { key: 'welding_positions', title: 'Welding positions', prepare: 'join' },
  { key: 'weld_detail_sorted', title: 'Weld details' },
  // { key: 'revalidation_methods', title: 'Revalidation methods', prepare: 'join' },
  // { key: 'type_of_current_polarites', title: 'Type of current and polarities', prepare: 'join' },
]

const certificateDataAsme = [
  { key: 'welding_processes', title: 'Welding processes', prepare: 'join' },
  { key: 'product_types', title: 'Product types', prepare: 'join' },
  { key: 'type_of_welds', title: 'Type of welds', prepare: 'join' },
  { key: 'type_of_weldings', title: 'Type of weldings', prepare: 'join' },
  { key: 'material_groups', title: 'Material groups', prepare: 'join' },
  { key: 'filler_material_groups', title: 'Filler metal F-number', prepare: 'join' },
  { key: 'dimension_t', title: 'Material thicknes (mm)' },
  { key: 'dimension_d', title: 'Outside pipe diam. (mm)' },
  { key: 'welding_positions', title: 'Welding positions', prepare: 'join' },
  { key: 'metal_transfers', title: 'Transfer mode', prepare: 'join' },
]

const certificateData = {
  'iso960612013': certificateDataIso,
  'iso147322013': certificateDataIso,
  'asme92017': certificateDataAsme
}

function prepareValue(rowData, CertData) {
  if (rowData.prepare === 'join') {
    return CertData[rowData.key].map(o => o.name || o).join(', ')
  } else {
    return CertData[rowData.key]
  }
}

function renderRows(certificate) {
  return certificateData[certificate.standard.slug].map(rowData => {
    return (
      <tr key={rowData.key}>
        <td>{rowData.title}</td>
        <td>{prepareValue(rowData, certificate)}</td>
        <td>{!rowData.noApproval && prepareValue(rowData, certificate.approval)}</td>
      </tr>
    )
  })
}

function renderDataRows(certificate, dataDictionary) {
  return Object.keys(certificate.data).map(key => {
    return (
      <tr key={key}>
        <td>{dataDictionary.find(o => o.id.toString() === key).name}</td>
        <td>{certificate.data[key]}</td>
        <td>{certificate.approval.data[key]}</td>
      </tr>
    )
  })
}

const SingleCertificateTable = ({ certificate, dataDictionary = [] }) => {
  if (certificate) {
    return (
      <CardBody style={{ paddingTop: '0px' }}>
        <div className='text-center'>
          <h1>WELDER QUALIFICATION TEST CERTIFICATE</h1>
          <h1>{certificate.standard.name}</h1>
        </div>
        <div>
          <p>Designation: <b>{certificate.designation}</b></p>
          <Row>
            <Col md={2}>
              <p>No: <b>{certificate.no}</b></p>
            </Col>
            <Col md={2}>
              <p>Expiration date: <b>{certificate.expiration_date}</b></p>
            </Col>
            <Col md={2}>
              <p>Publisher: <b>{certificate.publisher}</b></p>
            </Col>
            <Col md={2}>
              <p>Next confirmation: <b>{certificate.next_confirmation}</b></p>
            </Col>
            <Col md={2}>
              <p>Last confirmation: <b>{certificate.last_confirmation}</b></p>
            </Col>
            <Col md={2}>
              <p>Certificate Valid: <b>{certificate.certificate_valid}</b></p>
            </Col>
          </Row>
        </div>
        <Table striped style={{ width: '100%' }}>
          <thead>
            <tr>
              <th scope="col" style={{ width: '20%' }} />
              <th scope="col" style={{ width: '30%' }}>Test designation</th>
              <th scope="col" style={{ width: '50%' }}>Range of qualifiactions</th>
            </tr>
          </thead>
          <tbody>
            {renderRows(certificate)}
            {renderDataRows(certificate, dataDictionary)}
            <tr>
              <td>Additional info</td>
              <td colSpan={2}>{certificate.additional_info}</td>
            </tr>
          </tbody>
        </Table>
      </CardBody>
    )
  } else {
    return <div />
  }
}

SingleCertificateTable.propTypes = {
  certificate: PropTypes.object,
}

export default SingleCertificateTable



// WEBPACK FOOTER //
// ./src/components/Welders/helpers/SingleCertificateTable.js